import Vue from 'vue';

/**
 * @author Duke
 *
 */
import topBar from './src/topBar.vue';

topBar.install = function (Vue) {
  Vue.component(topBar.name, topBar);
};

export default topBar;



// WEBPACK FOOTER //
// ./ui/topBar/index.js